import { ProceduresPermissions } from '../../procedures/enums/procedures-permissions.enum';

export const UserPermissions = {
  Program: {
    Read: 'ProgramRead',
    ReadAndWrite: 'ProgramReadAndWrite',
    DeleteAndArchieve: 'ProgramDeleteAndArchieve',
  },

  Course: {
    Read: 'CourseRead',
    ReadAndWrite: 'CourseReadAndWrite',
    DeleteAndArchieve: 'CourseDeleteAndArchieve',
    AssignStudent: 'CourseAssignStudent',
    ChangeStatus: 'CourseChangeStatus',
    AttendanceStudent: 'CourseAttendanceStudent',
  },

  CourseApprovement: {
    Read: 'CourseApprovementRead',
    Creator: 'CourseApprovementCreator',
    Approval: 'CourseApprovementApprovel',
    Delegate: 'CourseApprovementDelegate',
  },

  User: {
    Read: 'UserRead',
    ReadAndWrite: 'UserReadAndWrite',
    Delete: 'UserDelete',
    ChangeStatus: 'UserChangeStatus',
    ChangeRole: 'ChangeUserRole',
    RoleManagement: 'RoleManagement',
  },

  Groups: {
    Read: 'GroupsRead',
    ReadAndWrite: 'GroupsCreate',
    Delete: 'GroupsReadAndWrite',
  },

  LearningPath: {
    Read: 'LearningPathRead',
    ReadAndWrite: 'LearningPathReadAndWrite',
    DeleteAndArchieve: 'LearningPathDeleteAndArchieve',
    AssignTrainees: 'LearningPathAssignTrainees',
  },

  TrainingPlan: {
    Read: 'TrainingPlanRead',
    ReadAndWrite: 'TrainingPlanReadAndWrite',
    DeleteAndArchieve: 'TrainingPlanDeleteAndArchieve',
    AssignTrainees: 'TrainingPlanAssignTrainees',
  },

  TrainingCenter: {
    Read: 'TrainingCenterRead',
    ReadAndWrite: 'TrainingCenterReadAndWrite',
    DeleteAndArchieve: 'TrainingCenterDeleteAndArchieve',
  },

  Enrollment: {
    View: 'EnrollmentView',
    Add: 'EnrollmentAdd',
    Delete: 'EnrollmentDelete',
    NominationManagement: 'NominationManagement',
    NominateAllCourses: 'EnrollmentNominateAllCourses',
  },

  Certificate: {
    Read: 'CertificateRead',
    ReadAndWrite: 'CertificateReadAndWrite',
    Delete: 'CertificateDelete',
  },

  Exam: {
    Read: 'ExaamRead',
    ReadAndWrite: 'ExaamReadAndWrite',
    Delete: 'ExaamView',
    Review: 'ExaamReview',
    Submit: 'ExaamSubmit',
  },

  PlatformFAQ: {
    Read: 'PlatformFaqView',
    ReadAndWrite: 'PlatformFaqCreate',
    Delete: 'PlatformFaqDelete',
  },
  DigitalLibrary: {
    Read: 'DigitalLibraryRead',
    ReadAndWrite: 'DigitalLibraryReadAndWrite',
    DeleteAndArchieve: 'DigitalLibraryDeleteAndArchieve',
  },

  Settings: {
    // Countries, Regios, and Cities,

    DashboardView: 'DashboardView',
    TeamMembersManagement: 'TeamMembersManagement',
    OrganiztionStructure: 'OrganiztionStructure',
    Location: 'LocationSetting',
    Identity: 'PlatformIdentitySettings',
    Translation: 'PlatformTranslationSettings',
    VideoConference: 'VideoConferenceSettings',
    TermsAndConditions: 'TermsAndConditionsSetting',
    Privacy: 'PrivacySetting',
    ContactUs: 'ContactUsSettings',
    AboutUs: 'AboutUSetting',
    MessagesAndNotification: 'MessagesAndNotificationSettings',

    Email: {
      Configuration: 'EmailConfigSetting',
      Template: 'EmailTemplateSettings',
    },

    Portal: {
      MainPage: 'MainPageSettings',
      Sections: 'SectionsSettings',
    },
  },
  BulkWriteReadCourse: {
    Read: 'ProgramRead',
    CourseReadAndWrite: 'CourseReadAndWrite',
    ExamReadAndWrite: 'ExaamReadAndWrite',
    CertificateReadAndWrite: 'CertificateReadAndWrite',
    VideoConference: 'VideoConferenceSettings',
  }

  // Procedures: ProceduresPermissions,
};